import { ReactNode } from "react";
import Grid from "@mui/material/Grid2";
import styles from './Contact.shared.module.scss';
import { Box, Divider, Stack } from "@mui/material";

export function ContactRootFrame({ mapChildren, contentChildren }: { mapChildren: ReactNode, contentChildren: ReactNode }) {
    return (
        <Grid
            container
            columns={{ xs: 1, md: 2 }}
            spacing={0}
            className={styles.contactRootGrid}
        >
            <Grid size={1}>{mapChildren}</Grid>
            <Grid size={1} className={styles.contactContentGridItem}>
                <Stack spacing={4} className={styles.contactContentStack}>
                    {contentChildren}
                </Stack>
            </Grid>
        </Grid>
    )
}

export function ContactGeneralOpeningHoursFrame({ children }: { children: ReactNode }) {
    return (
        <>
            <Divider className="w-full" />
            {children}
        </>
    )
}

export function ContactSpecialOpeningHoursFrame({ children, title }: { children: ReactNode, title: ReactNode }) {
    return (
        <>
            <Divider className="w-full" />
            <Stack spacing={1} sx={{ width: '100%', height: 'auto' }}>
                {title}
                <Box className={styles.contactSpecialOpeningHours}>
                    {children}
                </Box>
            </Stack>
        </>
    )
}
